import { getFeApolloInfoAjax } from '@/apiData/common'
import { compareVs } from '@/utils/compareVersion'
import { lego } from '@zz-common/lego'
import native from '@zz-common/native-adapter'
import { SentryCapture } from '@zz-common/sentry'
import { cookie, env, url } from '@zz-common/zz-utils'
import { Calculate } from '@zz-yp/bm-utils'
import packageInfo from '../../package.json'

const pkg = packageInfo
// 主动上报信息
function sentry2Erro(erroName, info) {
  SentryCapture('主动上报信息', -1, {
    extra: { href: location.href, erroName, ...info }
  })
}

function FormatDate(date, format) {
  const padStart = (value, length, char) => {
    value = value + ''
    const len = length - value.length
    if (len <= 0) {
      return value
    } else {
      return Array(len + 1).join(char) + value
    }
  }
  let _date = date
  const splitArr = (format && format.split(/(YYYY|MM|DD|hh|mm|ss)+/)) || []
  if (typeof date !== 'object') {
    _date = new Date(date)
  }
  return splitArr
    .map((item) => {
      if (item === 'YYYY') {
        return _date.getFullYear()
      }
      if (item === 'MM') {
        return padStart(_date.getMonth() + 1, 2, 0)
      }
      if (item === 'DD') {
        return padStart(_date.getDate(), 2, 0)
      }
      if (item === 'hh') {
        return padStart(_date.getHours(), 2, 0)
      }
      if (item === 'mm') {
        return padStart(_date.getMinutes(), 2, 0)
      }
      if (item === 'ss') {
        return padStart(_date.getSeconds(), 2, 0)
      }
      return item
    })
    .join('')
}
/**
 * 比较每日两个时间点的大小
 * @param {string} firstH 第一个时间 hh:mm
 * @param {string} vsH 第二个时间 hh:mm
 * @returns {boolean} 第一个时间比第二个时间大
 */
function vsDayHour(firstH, vsH) {
  const newData = new Date().getTime()
  const defaultH = vsH || FormatDate(newData, 'hh:mm')
  let defaultNum = defaultH?.replace(/\s+/g, '')?.replace(':', '.')
  let firstNum = firstH?.replace(/\s+/g, '')?.replace(':', '.')
  firstNum = Number(firstNum)
  console.log('firstNum: ', firstNum);
  defaultNum = Number(defaultNum)
  console.log('defaultNum: ', defaultNum);
  return firstNum > defaultNum
}

function updateUrlParameter(param, newval, search) {
  const regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?')
  const query = search.replace(regex, '$1').replace(/&$/, '')
  return (query.length > 2 ? query + '&' : '?') + (newval ? param + '=' + newval : '')
}
function getUrlParameter(name, str = '') {
  const reg = new RegExp('(\\?|&)' + name + '=([^&]*)' + '(&|$)')
  const arr = str ? str.match(reg) : window.location.search.match(reg)
  if (arr != null) {
    return decodeURI(arr[2])
  }
  return null
}

const alert = {
  forbiddenScroll: () => {
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
    document.body.style.height = window.innerHeight + 'px'
  },
  canScroll: () => {
    document.documentElement.style.overflow = 'auto'
    document.body.style.overflow = 'auto'
    document.body.style.height = 'auto'
  }
}

function formatMoney(num) {
  if (isNaN(num)) return num
  num = num.toFixed(2)
  num = parseFloat(num)
  num = num.toLocaleString()
  return num
}
function fen2yuan(num) {
  if (!num) return 0
  if (isNaN(num)) return num
  num = Calculate.div(num, 100)
  return num
}
// 保证一定精确两位小数
export const fen2yuan2fixed = (num, fixed = 2) => {
  return fen2yuan(num).toFixed(fixed)
}

function yuan2fen(num) {
  if (!num) return 0
  if (isNaN(num)) return num
  num = Calculate.mul(num, 100)
  return num
}

function formatDuring(mss) {
  let days = parseInt(mss / (1000 * 60 * 60 * 24))
  let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60))
  let seconds = Math.ceil((mss % (1000 * 60)) / 1000)
  if (seconds === 60) {
    seconds = '00'
    minutes = minutes + 1
  }
  if (minutes === 60) {
    minutes = '00'
    hours = hours + 1
  }
  if (hours === 24) {
    hours = '00'
    days = days + 1
  }
  return {
    day: days,
    hour: hours.toString().length === 1 ? '0' + hours : hours,
    minute: minutes.toString().length === 1 ? '0' + minutes : minutes,
    second: seconds.toString().length === 1 ? '0' + seconds : seconds
  }
}

function getOffset(ele) {
  let t = (ele && ele.offsetTop) || 0
  let l = (ele && ele.offsetLeft) || 0
  if (ele) {
    while ((ele = ele.offsetParent)) {
      t += ele.offsetTop
      l += ele.offsetLeft
    }
  }
  return {
    top: t,
    left: l
  }
}

/**
 * 兼容 getBoundingClientRect 的 top、left、width、height
 * @param {HTMLElement} el 元素
 * @return {object} obj
 */
function getOffsetWindow(el) {
  if (el && el.getBoundingClientRect) {
    return el.getBoundingClientRect()
  }
  const obj = getOffset(el)
  return {
    top: obj.top - window.scrollY,
    left: obj.left - window.scrollX,
    width: el && el.offsetWidth,
    height: el && el.offsetHeight
  }
}

/**
 * 节流函数
 * @param {function} func 需要执行的函数
 * @param {nunmber} wait 节流的时长
 */
function throttle(func, wait = 200) {
  let timeout = null
  return function() {
    const that = this
    const args = arguments
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null
        func.apply(that, args)
      }, wait)
    }
  }
}
/**
 * 防抖函数
 * @param {Function} func - 要防抖的函数
 * @param {number} wait - 等待时间（毫秒）
 * @returns {Function} 防抖后的函数
 */
function debounce(func, wait = 300) {
  let timeout
  return function() {
    const that = this
    const args = arguments

    // 清除之前的定时器
    if (timeout) clearTimeout(timeout)

    // 设置新的定时器，在 wait 时间后执行函数
    timeout = setTimeout(() => {
      func.apply(that, args)
      timeout = null
    }, wait)
  }
}

/**
 * 返回上一个页面
 */
function goBackPage() {
  if (history.length > 1) {
    // history.length 只是记录路由栈里有几个路由，并不是记录当前路由之前还有几个路由，
    // 所以不能认为 history.length > 1，就认为还有hash路由，需要进行一个判断
    try {
      native.wrap('hide')()
      history.back()
    } catch (error) {
      console.log(error);
    }
    const timer = setTimeout(() => {
      native.wrap('close')()
    }, 200)
    window.onpopstate = () => {
      // 如果触发了此方法，说明 hash路由改变了，否则说明并没有hash路由了，直接关闭 webview
      clearTimeout(timer)
    }
  } else {
    // 没有 hash路由栈，则直接关掉当前 webview
    native.wrap('close')()
  }
}

/**
 *  设置cookie
 */
function setCookie(key, value, encode) {
  // 是否对目标编码
  if (encode) {
    cookie.set(key, encodeURIComponent(value), {
      expires: 7,
      domain: '.zhuanzhuan.com'
    })
  } else {
    cookie.set(key, value, { expires: 7, domain: '.zhuanzhuan.com' })
  }
}
function getCookie(key) {
  // 是否对目标编码
  return cookie.get(key)
}

function getDeviceInfo() {
  const ua = navigator.userAgent
  const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
  const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  return {
    isAndroid,
    isiOS
  }
}
// 兼容页面，会重定向到新链接
function locationReplace(repalceUrl, params) {
  if (!repalceUrl) return
  const hashObj = url.getHashParams(location.href)
  const queryObj = url.getParams(location.href)
  const currentQuery = Object.assign({}, hashObj, queryObj)
  const repalceHashObj = url.getHashParams(repalceUrl)
  const repalceQueryObj = url.getParams(repalceUrl)
  let replaceQuery = Object.assign({}, repalceHashObj, repalceQueryObj)
  replaceQuery = Object.assign({}, currentQuery, replaceQuery, params)
  let urlNew = repalceUrl
  urlNew = url.setParams(replaceQuery, urlNew)
  location.replace(urlNew)
}

function clickLog(value, isClick = true) {
  try {
    if (!value) return
    const channel = getChannel()
    const bmOrderPlanType = window.sessionStorage.getItem('bmOrderPlanType')
    const obj = typeof value === 'string' ? { actiontype: value } : value
    let { actiontype, ...rest } = obj
    const type = isClick ? '__CLICK' : '__SHOW'
    actiontype = actiontype.toUpperCase() + type
    const pathName = location.pathname || ''
    let name = pathName.split('/')
    name = (name.length && name[name.length - 1]) || ''
    name = /[0-9]{9,}$/.test(name) ? 'auctionroom-item' : name
    let planType = ''
    // 新增D方案
    switch (name) {
      case 'correlate-Hplan-index':
        planType = 'H'
        break
      case 'correlate-Hplan-second':
        planType = 'H'
        break
      default:
        break
    }
    planType = name === 'order-detail' && bmOrderPlanType === 'F' ? 'F' : planType
    const logsMark = `U_BM-Main_${name}` // 埋点标识
    const legoParams = getParamsByCookie()
    const curBackup = { ...rest, ...legoParams, logsMark, urlRouterName: name, channel, planType }
    lego.send({
      // pagetype: `BM-${name.toUpperCase()}`,
      actiontype,
      backup: curBackup
    })
  } catch (error) {
    console.log(error)
  }
}

function getChannel() {
  let channel = window.localStorage.getItem('channel')
  channel = url.getParam('channel') || channel
  return channel
}
// const toRealPx = (designPx) => {
//   return parseInt((designPx / 750) * document.documentElement.getBoundingClientRect().width)
// }

const toRealPx = (designPx, type = 'width') => {
  const typeList = [
    {
      type: 'width',
      base: 750
    },
    {
      type: 'height',
      base: 1334 // 基于ihpone 6/7/8
    }
  ]
  const currentBase = typeList.reduce((s, item) => {
    if (item.type == type) {
      s = item.base
    }
    return s
  }, 0)
  return parseInt((designPx / currentBase) * document.documentElement.getBoundingClientRect()[type])
}
// 主动捕获异常上报lego
function catchErrSendLego(actiontype, backup) {
  const baseInfo = {
    project: pkg.name,
    url: location.href
  }
  const curBackup = Object.assign({}, baseInfo, backup)
  lego.send({
    actiontype,
    backup: curBackup
  })
}
// 页面需要定位到dom位置
function scrollIntoView(refDom, time) {
  setTimeout(() => {
    if (refDom) {
      const scrollTopH = refDom.offsetTop || 800
      const step = getDeviceInfo().isAndroid ? 150 : 200
      window.scrollTo(0, scrollTopH - step)
    }
  }, time)
}
// <$red 替换色值  eg: <$blue 文字描述 $>
function replaceHtml(string, color) {
  console.log('replaceHtml: ', string, color);
  let colorNum = '#f33'
  switch (color) {
    case 'red' :
      colorNum = '#f33'
      break
    case 'blue' :
      colorNum = '#6D9CF8'
      break
    case 'lightBlue':
      colorNum = '#7792D8'
      break
    default:
      break
  }
  const text = string
    ? string.split(`<$${color}`).join(`<span class="${color}" style="color: ${colorNum}">`).split('$>').join('</span>').split('<$del').join('<span style="text-decoration: line-through">')
    : ''
  return text
}
// 从cookie中获取参数
function getParamsByCookie() {
  try {
    const { model = '', brand = '' } = cookie.get() || {}
    const systemModel = url.getParam('__model') || model || ''
    return { systemModel, systemBrand: brand }
  } catch (error) {
    return {}
  }
}

/**
 * 过滤url链接上的估价相关的sku参数
 */
function filterIds(query) {
  const idParams = Object.keys(query).filter((item) => {
    return item.includes('Id') // 目前，先用这种方式可排除掉needHideHead
  })
  const currentParams = idParams.reduce((s, i) => {
    s[i] = query[i]
    return s
  }, {})
  return currentParams
}

// 是否为手机平板
const isPhoneOrPad = (cateId) => {
  return ['101', '119'].indexOf(cateId?.toString()) > -1
}
// 是否为笔记本
const isLaptop = (cateId) => {
  return cateId == '1100000016'
}

// 是否为数码小品类
const isDigital = (cateId) => {
  return ['1100000170', '1100000171', '1100000186', '1100000187', '1100000197', '2128017512', '1100000665', '1100000040'].indexOf(cateId?.toString()) > -1
}
// 是否为数码小品类，异步方法获取Apollo配置进行判断
const isDigitalAsync = async(cateId) => {
  try {
    const res = await getFeApolloInfoAjax({ keys: 'bm_parent_cate_config.digital' })
    return res.indexOf(cateId?.toString()) > -1
  } catch (error) {
    console.log('isDigitalAsync error: ', error);
    return false
  }
}

// 是否为摄影器材小品类
const isPhotography = (cateId) => {
  return ['1100001138', '1100000179', '1100000180', '1100001139', '1100000182'].indexOf(cateId?.toString()) > -1
}
// 是否为摄影器材小品类，异步方法获取Apollo配置进行判断
const isPhotographyAsync = async(cateId) => {
  try {
    const res = await getFeApolloInfoAjax({ keys: 'bm_parent_cate_config.photography' })
    return res.indexOf(cateId?.toString()) > -1
  } catch (error) {
    console.log('isPhotographyAsync error: ', error);
    return false
  }
}

// 机型选择页数码 TAB 下的数码品类，目前只有耳机不在
const inDigitalTab = (cateId) => {
  return ['1100000170', '1100000171', '1100000187', '1100000197', '2128017512', '1100000665', '1100000040'].indexOf(cateId?.toString()) > -1
}

// 无人机品类 属于聚合回收品类，但是不放到聚合回收品类下，放在数码下
const isAggregateButInDigital = (cateId) => {
  return ['1100000172'].includes(cateId?.toString())
}

/**
 * 通过api获取机型信息
 */
const getModelByApi = () => {
  return new Promise((resolve, reject) => {
    if (!native.in('zz')) return resolve('')
    native.wrap('getPhoneInfo')({}, (res) => {
      const { model } = res || {}
      model ? resolve(model) : reject(new Error())
    })
  })
}

/*
 * 获取本机机型
*/
const getModelName = async() => {
  let systemModel = ''
  try {
    const { __model } = url.getParams(location.href) || {}
    systemModel = __model || cookie.get('model') || ''
    if (!systemModel) {
      systemModel = await getModelByApi()
    }
  } catch (err) {
    console.log('err: ', err);
    SentryCapture('主动上报，获取本机机型错误', -1, {
      tags: { myLevel: 'error' },
      extra: { href: location.href, errorName: err && err.name, err }
    })
  }
  return systemModel
}

// 对象属性值是否相等（深度遍历）
const deepEqual = (x, y) => {
  // 指向同一内存时
  if (x === y) {
    return true
  } else if (typeof x == 'object' && x != null && typeof y == 'object' && y != null) {
    if (Object.keys(x).length !== Object.keys(y).length) {
      return false
    }
    for (const prop in x) {
      if (prop in y) {
        if (!deepEqual(x[prop], y[prop])) return false
      } else {
        return false
      }
    }
    return true
  } else {
    return false
  }
}

// 判断转转App是否支持新半层
const canUseNewHalfScreen = () => {
  if (!native.in('zz')) return false
  if (compareVs('9.16.0') < 0) return false
  if (env.$isIOS) {
    const deviceVersion = env.getIphoneVersion()
    return parseInt(deviceVersion) >= 13
  }
  return true
}

// 跳转半层webview
const jumpHalfWebviewUrl = (
  targetUrl,
  halfScreenParams = {
    needHideHead: 3,
    hiddenProgress: 1,
    isShowOnWindow: 1,
    webShowType: 1,
    topLeftRadius: 32,
    topRightRadius: 32,
    pHeight: 80
  }
) => {
  const { webShowType } = url.getParams() || {}
  // 支持新版半层 且 当前页面不是旧版半层 --> 使用新版进行跳转
  if (canUseNewHalfScreen() && webShowType != 1) {
    halfScreenParams = {
      needHideHead: 3,
      hiddenProgress: 1,
      wvHalfVer: 'v2',
      wvCornerRadius: 32,
      wvHeightRate: 0.8
    }
  }
  if (native.in('zz')) {
    targetUrl = url.setParams(halfScreenParams, targetUrl)
  }
  return targetUrl
}

export const numberToFixed = (num, fixed = 2) => {
  return Number(num).toFixed(fixed)
}
/**
 * 处理接口错误，如果 respCode 为 -11062，则提示并刷新页面
 * @param {Object} error - 错误对象
 * @param {Function} toast - toast 方法，用于显示提示
 * @returns {Boolean} 返回 true 表示已处理，false 表示未处理
 */
export const handleApiErrorWithRefresh = (error, toast) => {
  const { respCode, errMsg } = error || {}
  if (respCode === -11062) {
    // toast 提示错误信息
    if (toast && typeof toast === 'function') {
      toast(errMsg || '操作失败，请重试')
    }
    // 500ms 后刷新页面
    setTimeout(() => {
      window.location.reload()
    }, 500)
    return true // 返回 true 表示已处理
  }
  return false // 返回 false 表示未处理
}

export {
  alert, catchErrSendLego, clickLog, debounce, deepEqual, fen2yuan, filterIds, FormatDate, formatDuring, formatMoney, getChannel, getCookie, getDeviceInfo, getModelByApi,
  getModelName, getOffset, getOffsetWindow, getParamsByCookie, getUrlParameter, goBackPage, inDigitalTab, isAggregateButInDigital, isDigital,
  isDigitalAsync, isLaptop, isPhoneOrPad, isPhotography,
  isPhotographyAsync, jumpHalfWebviewUrl, locationReplace, replaceHtml, scrollIntoView, sentry2Erro, setCookie, throttle, toRealPx, updateUrlParameter, vsDayHour, yuan2fen
}
